(function($) {
    let cBuildingSearchObjectCounter = 0;

    $.widget("ui.BuildingSearch",
        {
            options:
            {
                PageContentId: null,
                InitialPagerData: null,
                BuildingResultSelector: '.building',
                ResultListSelector: '.building_list',
                BuildingGallerySelector: '.building_search_results',
                MoreContainerSelector: '.building_list',
                LinkedBuildingClass: 'fbcms_linkedbuilding',
                BuildingInfoUrl: "/Core/Buildings/Block/",
                BuildingInfoLoadingTitle: 'Loading Building',
                BuildingInfoSuccessTitle: 'School Details',
                BuildingInfoErrorTitle: 'Error Loading School Details',
                BuildingInfoLoadingContent: 'Loading School Details.',
                BuildingInfoErrorContent: 'Error loading School Details.'
            },

            _destroy: function() {
            },

            _init: function() {
            },

            _MyObjectNumber: null,

            _create: function() {
                const self = this;
                const jElement = $(self.element);
                if (self.options.PageContentId === null) {
                    return;
                }

                if (FBUtilities.IsStringEmptyOrWhitespace(self.options.ResultListSelector)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.LinkedBuildingClass)
                    || FBUtilities.IsStringEmptyOrWhitespace(self.options.BuildingGallerySelector)) {
                    FBUtilities.LogMessage('BuildingSearch - required settings null or empty.');
                    return;
                }

                self._MyObjectNumber = cBuildingSearchObjectCounter++;

                const buildingSearchResultId = 'BuildingSearchResult' + self._MyObjectNumber;

                const jResultsContainer = jElement.find(self.options.BuildingGallerySelector);
                jResultsContainer.attr('role', 'region');
                jResultsContainer.attr('aria-live', 'polite');
                jResultsContainer.attr('id', buildingSearchResultId);

                self.SetupBuildingButtons();

                const jGallery = jElement.find(self.options.BuildingGallerySelector);
                const jContainer = jElement.find(self.options.ResultListSelector);
                const jBuildings = jContainer.find(self.options.BuildingResultSelector);
                jBuildings.addClass(self.options.LinkedBuildingClass);

                const buildingCardSelector = self.options.BuildingResultSelector + "[data-building-url]," + self.options.BuildingResultSelector + "[data-building-id]";
                jGallery.on(
                    'click',
                    buildingCardSelector,
                    function(aEvent) {
                        aEvent.preventDefault();
                        const jTarget = $(aEvent.target);
                        const jBuilding = jTarget.parents(self.options.BuildingResultSelector);
                        const buildingId = jBuilding.data('building-id');
                        if (FBUtilities.IsParameterUndefinedOrNull(buildingId) === false) {
                            self.SelectBuilding(buildingId, aEvent.target);
                            return false;
                        }

                        const url = jBuilding.data('building-url');
                        if (FBUtilities.IsParameterUndefinedOrNull(url) === false) {
                            window.location = url;
                        }
                        return false;
                    }
                );

                jGallery.on(
                    'keypress',
                    buildingCardSelector,
                    function(aEvent) {
                        if (aEvent.key !== "Enter" && aEvent.key !== " " && aEvent.key !== "Spacebar") {
                            return
                        }

                        aEvent.preventDefault();
                        const jCard = $(this);
                        const buildingId = jCard.data('building-id');
                        if (FBUtilities.IsParameterUndefinedOrNull(buildingId) === false) {
                            self.SelectBuilding(buildingId, this);
                            return false;
                        }

                        const url = jCard.data('building-url');
                        if (FBUtilities.IsParameterUndefinedOrNull(url) === false) {
                            window.location = url;
                        }
                        return false;
                    }
                );

                self.SetupPagination();

                const jSearchButton = jElement.find('.search_button');
                jSearchButton.click(function(aEvent) {
                    aEvent.preventDefault();
                    self.Search();
                    return false;
                });
                jSearchButton.attr('aria-controls', buildingSearchResultId);

                const jResetButton = jElement.find('.reset_button');
                jResetButton.click(function(aEvent) {
                    aEvent.preventDefault();
                    self.Reset();
                    return false;
                });
                jResetButton.attr('aria-controls', buildingSearchResultId);

                const jFilterSearchText = jElement.find('input[name="SearchText"]');
                jFilterSearchText.attr('aria-controls', buildingSearchResultId);
                jFilterSearchText.on(
                    'keypress',
                    function(aEvent) {
                        if (aEvent.key === "Enter") {
                            aEvent.preventDefault();
                            self.Search();
                            return false;
                        }
                        // nevermind, carry on...
                        return true;
                    }
                );

                //self.Reset();
            },

            Reset: function() {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.building_search_form');

                // reset all input fields.
            jFormDiv.find('input[name="SearchText"]').val('');
                jFormDiv.find('.category_filter select').map(function(i, v) {
                    $(this).val('');
                });

            jElement.find('.building_search_form').find('input[name="IsReset"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            GetSearchData: function() {
                const self = this;
                const jElement = $(self.element);
                const jFormDiv = jElement.find('.building_search_form');
                const searchData = {
                    "PageContentId": self.options.PageContentId,
                "FromBuildingSearchForm": jFormDiv.find('input[name="IsNewSearch"]').val(),
                "ResetBuildingSearchForm": jFormDiv.find('input[name="IsReset"]').val(),
                "SearchText": jFormDiv.find('input[name="SearchText"]').val(),
                    "SelectedTagIds": jFormDiv.find('.category_filter select').find(":selected").map(function(i, v) {
                        return $(this).val();
                    }).toArray()
                };

            jFormDiv.find('input[name="IsNewSearch"]').val('');
            jFormDiv.find('input[name="IsReset"]').val('');

                return searchData;
            },

            Search: function() {
                const jElement = $(this.element);
            jElement.find('.building_search_form').find('input[name="IsNewSearch"]').val('True');
                jElement.AjaxContentPagination('ChangePage', 1);
            },

            SetupPagination: function() {
                const self = this;
                const jElement = $(self.element);
                const buildingSearchResultId = 'BuildingSearchResult' + self._MyObjectNumber;
                const jResultsContainer = jElement.find(self.options.BuildingGallerySelector);
                const jMoreContainer = jResultsContainer.find(self.options.MoreContainerSelector);

                jElement.AjaxContentPagination(
                    {
                        NavigationUrl: `/Core/Buildings/Search/${self.options.PageContentId}/`,
                        LoadingTitle: "School Search",
                        NormalContainer: jResultsContainer,
                        MoreContainer: jMoreContainer,
                        OnSuccess: function(mode, data, textStatus, jqXHR) {
                            self.SetupBuildingButtons();
                        },
                        InitialPagerData: self.options.InitialPagerData,
                        RequestDataFunc: function() {
                            return self.GetSearchData();
                        },
                        LiveRegionId: buildingSearchResultId
                    });
            },

            SetupBuildingButtons: function() {
                const selector = this.options.BuildingResultSelector + "[data-building-url]," + this.options.BuildingResultSelector + "[data-building-id]";
                $(this.element).find(selector).css('cursor', 'pointer');
            },

            SelectBuilding: function(aBuildingId, aSelectionElement) {
                if (!FBUtilities.IsStringEmptyOrWhitespace(this.options.BuildingInfoUrl)) {
                    new FBAjaxDialog().Start({
                        AjaxUrl: `${this.options.BuildingInfoUrl}${aBuildingId}`
                        , Data: { ParentContentId: this.options.PageContentId }
                        , ExtraDialogClasses: 'fbd_building'
                        , LoadingDialogTitle: this.options.BuildingInfoLoadingTitle
                        , SuccessDialogTitle: this.options.BuildingInfoSuccessTitle
                        , ErrorDialogTitle: this.options.BuildingInfoErrorTitle
                        , LoadingContent: this.options.BuildingInfoLoadingContent
                        , ErrorContent: this.options.BuildingInfoErrorContent
                        , SelectionElement: aSelectionElement
                    });
                }
            }
        });
})(jQuery);
